import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { io } from "socket.io-client";

const VariableContext = createContext();
const CONFIG = require("./config.json");
const parser = require("./parser");
parser.configure(CONFIG);

export const useVariables = () => useContext(VariableContext);

export const VariableProvider = ({ children }) => {
  const [variables, setVariables] = useState({});
  const socketRef = useRef(null);

  useEffect(() => {
    console.log("variable context starting socket");

    // const socket = io('https://mykns.ru'); //TODO: remove URL literal
    // const socket = io("http://localhost:3001"); //TODO: remove URL literal
    console.log(process.env.REACT_APP_SOCKET_URL);
    

    const socket = io(process.env.REACT_APP_SOCKET_URL, {
  path: "/socket.io",
  transports: ["websocket"],
});

    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("🔌 Подключено к серверу");
    });

    socket.on("ping", (data) => {
      console.log("ping:", data);
    });

    socket.on("init", (vars) => {
      setVariables(vars);
    });

    socket.onAny((event, ...args) => {
      console.log(`${event}:`, args);
    });

    // socket.on("var", ({ name, value }) => {
    //   setVariables((prev) => ({
    //     ...prev,
    //     [name]: value,
    //   }));
    // });

    socket.on("logs", async ({ log, line }) => {
      try {
        if (!parser.valid_log(log)) {
          console.warn(`⚠️ logs: неизвестный лог "${log}"`);
          return;
        }

        const parsed = parser.parseBySpec(line, log);
        console.log(parsed);

        const { values } = parsed;
        if (values) {
          for (const [name, value] of Object.entries(values)) {
            setVariables((prev) => ({
              ...prev,
              [name]: value,
            }));
          }
        }
      } catch (err) {
        console.error("Ошибка logs:");
        // console.error("Ошибка logs:", err);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <VariableContext.Provider value={{ variables }}>
      {children}
    </VariableContext.Provider>
  );
};
